import { http } from 'services/http';
import type { TOpenAiParserOrderRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IUploadDocumentVariables {
  data: FormData;
  onUploadProgress?: (event: ProgressEvent) => void;
  onSuccess?: (body: TOpenAiParserOrderRes) => void;
}

export const useUploadFileToAi = () => {
  return useMutationBase<TOpenAiParserOrderRes, unknown, IUploadDocumentVariables>({
    mutationFn: async (variables) => {
      const { data, onUploadProgress, onSuccess } = variables;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const handleUploadProgress = (value: any) => {
        if (onUploadProgress) onUploadProgress({ ...value.event, percent: value.progress * 100 });
      };

      const res = await http.post<TOpenAiParserOrderRes>('/v1/ai-parser/order', data, {
        onUploadProgress: handleUploadProgress,
      });

      if (onSuccess) onSuccess(res.data);
      return res.data;
    },
  });
};
